var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M14.425 7.953a3.98 3.98 0 0 1 .562 2.045 3.98 3.98 0 0 1-.583 2.08L18 15.671V12.98c0-.248.097-.496.29-.689.379-.379 1.047-.38 1.426 0a.94.94 0 0 1 .283.696l-.001 5.049a.957.957 0 0 1-.276.69.955.955 0 0 1-.69.273h-5.059a.971.971 0 0 1-.689-.289 1.026 1.026 0 0 1 0-1.417.972.972 0 0 1 .69-.29h2.702l-3.634-3.573a3.998 3.998 0 0 1-5.924-2.431H1a1 1 0 0 1 0-2h6.12a3.998 3.998 0 0 1 5.96-2.409L16.665 3l-2.694-.001a.972.972 0 0 1-.689-.29 1.035 1.035 0 0 1 0-1.425.94.94 0 0 1 .696-.283l5.05.001c.248 0 .497.083.69.276a.954.954 0 0 1 .272.69l.001 5.052a.971.971 0 0 1-.29.689 1.028 1.028 0 0 1-1.419 0 .972.972 0 0 1-.29-.69V4.323l-3.567 3.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowBranch);
export default __webpack_public_path__ + "static/media/flow-branch.26dbaa76000d0df784c87377b6983013.svg";
export { ForwardRef as ReactComponent };